<template>
  <admin-page-frame>
    <school-list-toolbar @search="loadList" @reset="handleReset">
      <template #filters>
        <el-select v-model="query.status" clearable size="small" placeholder="审批状态" class="filter-item" style="width: 130px; margin-right: 10px;">
          <el-option label="待审批" value="pending" /><el-option label="已通过" value="approved" /><el-option label="已驳回" value="rejected" /><el-option label="已撤销" value="cancelled" />
        </el-select>
        <el-input v-model="query.keyword" clearable size="small" placeholder="请假单号" class="filter-item" style="width: 180px; margin-right: 10px;" @keyup.enter.native="loadList" />
        <el-select v-model="query.leaveType" clearable size="small" placeholder="请假类型" class="filter-item" style="width: 120px; margin-right: 10px;">
          <el-option label="事假" value="personal" /><el-option label="病假" value="sick" />
        </el-select>
      </template>
    </school-list-toolbar>
    <el-table v-loading="loading" :data="list" :border="false" size="small" style="width: 100%;">
      <el-table-column prop="requestNo" label="请假单号" min-width="150" show-overflow-tooltip />
      <el-table-column prop="studentId" label="学员ID" width="90" />
      <el-table-column prop="classId" label="班级ID" width="90" />
      <el-table-column prop="sessionId" label="课次ID" width="90" />
      <el-table-column label="类型" width="80" align="center"><template slot-scope="{ row }">{{ leaveTypeLabel(row.leaveType) }}</template></el-table-column>
      <el-table-column prop="reason" label="原因" min-width="160" show-overflow-tooltip />
      <el-table-column label="状态" width="90" align="center"><template slot-scope="{ row }"><el-tag :type="leaveStatusType(row.status)" size="mini">{{ leaveStatusLabel(row.status) }}</el-tag></template></el-table-column>
      <el-table-column label="操作" min-width="140" width="140" align="center" fixed="right" class-name="admin-pc-table-actions-col">
        <template slot-scope="{ row }"><div class="admin-pc-table-actions"><template v-if="row.status === 'pending'"><el-button type="text" size="mini" @click="handleApprove(row)">通过</el-button><el-button type="text" size="mini" class="admin-pc-table-actions__danger" @click="handleReject(row)">驳回</el-button></template><span v-else style="color: #c0c4cc;">-</span></div></template>
      </el-table-column>
    </el-table>
    <school-list-pagination :total="total" :page="query.page" :size="query.size" @page-change="onPageChange" @size-change="onSizeChange" />
  </admin-page-frame>
</template>
<script>
import AdminPageFrame from './components/AdminPageFrame.vue'
import SchoolListToolbar from './components/SchoolListToolbar.vue'
import SchoolListPagination from './components/SchoolListPagination.vue'
import schoolListPageMixin from './mixins/school-list-page'
import { fetchSchoolLeaveRequests, approveSchoolLeaveRequest, rejectSchoolLeaveRequest } from '@/api/h5-admin-schools'
import './schools-admin.less'
const DEFAULT_QUERY = { status: null, keyword: '', leaveType: null, page: 0, size: 20 }
export default {
  name: 'SchoolsLeave', components: { AdminPageFrame, SchoolListToolbar, SchoolListPagination }, mixins: [schoolListPageMixin],
  data() { return { loading: false, list: [], total: 0, query: { ...DEFAULT_QUERY } } },
  created() { this.loadList() },
  methods: {
    handleReset() { this.resetListQuery(DEFAULT_QUERY) },
    leaveTypeLabel(v) { const map = { personal: '事假', sick: '病假' }; return map[v] || v || '-' },
    leaveStatusLabel(v) { const map = { pending: '待审批', approved: '已通过', rejected: '已驳回', cancelled: '已撤销' }; return map[v] || v || '-' },
    leaveStatusType(v) { const map = { pending: 'warning', approved: 'success', rejected: 'danger', cancelled: 'info' }; return map[v] || 'info' },
    hasClientFilter() { return !!(this.query.keyword || this.query.leaveType) },
    applyClientFilters(rows) {
      let list = rows || []
      const kw = (this.query.keyword || '').trim()
      if (kw) list = list.filter(r => (r.requestNo || '').includes(kw))
      if (this.query.leaveType) list = list.filter(r => r.leaveType === this.query.leaveType)
      return list
    },
    loadList() {
      this.loading = true
      const hasClientFilter = this.hasClientFilter()
      const params = { status: this.query.status || undefined, page: hasClientFilter ? 0 : this.query.page, size: hasClientFilter ? 500 : this.query.size }
      fetchSchoolLeaveRequests(params).then(res => {
        let list = (res && res.content) || []; list = this.applyClientFilters(list)
        if (hasClientFilter) { this.total = list.length; const start = this.query.page * this.query.size; list = list.slice(start, start + this.query.size) } else { this.total = (res && res.totalElements) || 0 }
        this.list = list
      }).finally(() => { this.loading = false })
    },
    handleApprove(row) { this.$confirm('确定通过该请假申请吗？通过后该课次不扣课时。', '审批通过', { type: 'warning' }).then(() => { approveSchoolLeaveRequest(row.requestNo, {}).then(() => { this.$message.success('已通过'); this.loadList() }) }).catch(() => {}) },
    handleReject(row) { this.$prompt('请输入驳回原因（可选）', '驳回请假', { confirmButtonText: '确定', cancelButtonText: '取消', inputPlaceholder: '驳回说明' }).then(({ value }) => { rejectSchoolLeaveRequest(row.requestNo, { approveRemark: value || '' }).then(() => { this.$message.success('已驳回'); this.loadList() }) }).catch(() => {}) }
  }
}
</script>